<h1>{{ 'referentiels.list.otpProperties.caption'| transloco }}</h1>

@if (userHasReadWritePermission) {
  <p-button [size]="'small'" pRipple [rounded]="true" label="{{ 'button.add' | transloco }}" icon="pi pi-plus" class="btn-light" (onClick)="ajouterOtp()"></p-button>
}

<p-table
  #otpTable
  [value]="otpResult"
  selectionMode="single"
  [(selection)]="selectedOtp"
  [resizableColumns]="true"
  columnResizeMode="expand"
  dataKey="id"
  editMode="row"
  [rows]="25"
  [rowsPerPageOptions]="[10, 25, 50]"
  styleClass="p-datatable-striped"
  [loading]="loading"
  [paginator]="true"
  [totalRecords]="totalRecords"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{{'jgrid.defaults.recordtext' | transloco}} {first} - {last} {{'jgrid.defaults.recordtextOf' | transloco}} {totalRecords}"
  [tableStyle]="{ 'min-width': '50rem'}"
>
  <ng-template pTemplate="header">
    <!-- Headers -->
    <tr>
      <th *ngIf="userHasReadWritePermission" style="width: 2%"></th>
      <th pResizableColumn pSortableColumn="eotp" style="width: 5%">{{ 'referentiels.list.otpProperties.eotp.header'| transloco }} <p-sortIcon field="eOtp" /></th>
      <th pResizableColumn pSortableColumn="designation" style="width: 20%">{{ 'referentiels.list.otpProperties.libelle.header'| transloco }} <p-sortIcon field="libelle" /></th>
    </tr>

    <!-- Filters Inputs -->
    <tr>
      <th *ngIf="userHasReadWritePermission"></th>
      <th>
        <p-columnFilter type="text" field="eotp" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par code" [showMenu]="false" [showClearButton]="false" />
      </th>
      <th>
        <p-columnFilter type="text" field="designation" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par libelle" [showMenu]="false" [showClearButton]="true" />
      </th>
    </tr>
  </ng-template>

  <!-- Body -->
  <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
    <ng-container [formGroup]="otpForm">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData">
        <td *ngIf="userHasReadWritePermission" (click)="onRowSelect(rowData)">
          <!-- Column for edit/save buttons -->
          <div class="flex align-items-center justify-content-center">
            <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" pTooltip="{{ 'button.edit' | transloco }}" (click)="modifierOtp(rowData, ri)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" size="small" pTooltip="{{ 'button.validate' | transloco }}" (click)="validerModifsOtp(rowData)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" size="small" pTooltip="{{ 'button.cancel' | transloco }}" (click)="annulerModifsOtp(rowData, ri)"></button>
          </div> 
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="eotp" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.eotp }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="designation" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.designation }}
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">{{ 'jgrid.defaults.emptyrecords' | transloco }}.</td>
    </tr>
  </ng-template>
</p-table>


<h1>{{ 'referentiels.list.gammeProperties.caption'| transloco }}</h1>

@if (userHasReadWritePermission) {
  <p-button [size]="'small'" pRipple [rounded]="true" label="{{ 'button.add' | transloco }}" icon="pi pi-plus" class="btn-light" (onClick)="ajouterGamme()"></p-button>
}

<p-table
  #otpTable
  [value]="gammeResult"
  selectionMode="single"
  [(selection)]="selectedGamme"
  [resizableColumns]="true"
  columnResizeMode="expand"
  dataKey="id"
  editMode="row"
  [rows]="25"
  [rowsPerPageOptions]="[10, 25, 50]"
  styleClass="p-datatable-striped"
  [loading]="loading"
  [paginator]="true"
  [totalRecords]="totalRecords"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{{'jgrid.defaults.recordtext' | transloco}} {first} - {last} {{'jgrid.defaults.recordtextOf' | transloco}} {totalRecords}"
  [tableStyle]="{ 'min-width': '50rem'}"
>
  <ng-template pTemplate="header">
    <!-- Headers -->
    <tr>
      <th *ngIf="userHasReadWritePermission" style="width: 2%"></th>
      <th pResizableColumn pSortableColumn="designation" style="width: 20%">{{ 'referentiels.list.gammeProperties.libelle.header'| transloco }} <p-sortIcon field="libelle" /></th>
    </tr>

    <!-- Filters Inputs -->
    <tr>
      <th *ngIf="userHasReadWritePermission"></th>
      <th>
        <p-columnFilter type="text" field="designation" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par libelle" [showMenu]="false" [showClearButton]="true" />
      </th>
    </tr>
  </ng-template>

  <!-- Body -->
  <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
    <ng-container [formGroup]="gammeForm">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData">
        <td *ngIf="userHasReadWritePermission" (click)="onRowGammeSelect(rowData)">
          <!-- Column for edit/save buttons -->
          <div class="flex align-items-center justify-content-center">
            <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" pTooltip="{{ 'button.edit' | transloco }}" (click)="modifierGamme(rowData, ri)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" size="small" pTooltip="{{ 'button.validate' | transloco }}" (click)="validerModifsGamme()"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" size="small" pTooltip="{{ 'button.cancel' | transloco }}" (click)="annulerModifsGamme(rowData, ri)"></button>
          </div> 
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="designation" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.designation }}
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">{{ 'jgrid.defaults.emptyrecords' | transloco }}.</td>
    </tr>
  </ng-template>
</p-table>
<p-toast />
